/**
 * 全文检索路由
 */
"use strict";
angular.module("fullSearchRouter", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state("search.fullsearch", {
        url: "/fullsearch?keywords",
        views: {
            'main@search': {
                templateUrl: './main/fullSearch/full_search.html',
                controller: 'fullSearchCtrl'
            }
        }
    });
}]);